﻿/*
lb.qs.js
Library to access, manipulate and manage the query string

Example usage:
    
Query string: '?A=aaa&B=bbb&C=ccc&A=ddd&E=e=ee'
    
location.qs.get( "A" );                     => ["aaa","ddd"]
location.qs.get( "B" );                     => ["bbb"]
location.qs.get( "C" );                     => ["e=ee"]
location.qs.exists( "A" );                  => true
location.qs.exists( "F" );                  => false
locaiton.qs.set( "F", "fff" );              => internal query string is '?A=aaa&B=bbb&C=ccc&A=ddd&E=e=ee&F=fff'
location.qs.hasMultiple( "A" );             => true
location.qs.hasMultiple( "B" );             => false
location.qs.hasMultiple( "G" );             => false
locaiton.qs.set( "A", "ggg" );              => internal query string is '?A=ggg&B=bbb&C=ccc&E=e=ee&F=fff'
location.qs.hasMultiple( "A" );             => false
location.qs.toString();                     => '?A=ggg&B=bbb&C=ccc&E=e=ee&F=fff'
location.qs.push( stateObjcet, "title" );   => push internal query string in browser history, update url box

*/

(function () {
	"use strict";

	var _dict = new Object();
	var _history = window.history;
	//if( !window.History.enabled ) HISTORY= window.History; // use history.js

	location.qs = new Object();

	function parseqs() {
		var querystring = unescape(location.search);
		if (!querystring || querystring.length == 1) {
			return;
		}
		querystring = querystring.substring(1);

		// '&' seperates key/value pairs
		var pairs = querystring.split("&");

		// Load the key/values of the return collection
		for (var i = 0; i < pairs.length; i++) {
			var j = pairs[i].indexOf("=");
			var key = pairs[i];
			var val = "";
			if (j > -1) {
				key = pairs[i].substr(0, j);
				val = pairs[i].substr(j + 1);
			}
			if (_dict[key] == undefined) {
				_dict[key] = [val];
			} else {
				_dict[key].push(val);
			}
		}
	}
	parseqs();

	function genkeys() {
		if (keys != undefined && keys.length > 0) return keys;
		var keys = new Object();
		for (var key in _dict) {
			keys[key] = 1;
		}
		return keys;
	};

	location.qs.keys = genkeys();

	location.qs.toString = function () {

		if (_dict.length == 0) {
			return "";
		}

		var toString = "?";

		for (var key in _dict) {
			var l = _dict[key].length;
			for (var i = 0; i < l; i++) {
				if (toString.length > 1) toString += "&";
				toString += key + "=" + _dict[key][i];
			}
		}

		return toString;
	};

	location.qs.reload = function () {
		parseqs();
		location.qs.keys = genkeys();
	};

	location.qs.get = function (key) {
		return _dict[key];
	};

	location.qs.set = function (key, val) {
		if (val instanceof Array && val.length > 0) _dict[key] = val;
		else _dict[key] = [val];
	};

	location.qs.exists = function (key) {
		return _dict[key] != undefined;
	};

	location.qs.hasMultiple = function (key) {
		return location.qs.exists(key) && _dict[key].length > 1;
	};

	location.qs.push = function (stateObject, title, qs) {
		_history.pushState(stateObject, title, qs == undefined ? location.qs.toString() : qs);
	};

})();
